export default __webpack_public_path__ + "cea99d3e3e13a3a599a015c29f1046d0.woff";